import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { memo } from "react";
import Drawer from "@mui/material/Drawer";
import Toolbar from "@mui/material/Toolbar";
import { Resizable } from "re-resizable";
import useLocalStorageState from "use-local-storage-state";
import { useResizableStyles, useSx } from "./ResizableDrawer.styles";
export const DefaultSidebarWidth = 240;
export const LocalStorageStudioSidebarWidthKey = "veezoo.studio.sidebar.width";
const ResizableDrawer = ({ isResizable, children }) => {
    const [sidebarWidth, setSidebarWidth] = useLocalStorageState(LocalStorageStudioSidebarWidthKey, {
        defaultValue: DefaultSidebarWidth,
        storageSync: false,
    });
    const { classes: resizableClasses } = useResizableStyles();
    const sx = useSx({ width: isResizable ? sidebarWidth : DefaultSidebarWidth });
    // if the initial sidebar width is bigger than the default sidebar width reset the sidebar width
    if (sidebarWidth > window.innerWidth && sidebarWidth > DefaultSidebarWidth) {
        setSidebarWidth(DefaultSidebarWidth);
    }
    return (_jsx(Resizable, { defaultSize: {
            width: isResizable ? sidebarWidth : DefaultSidebarWidth,
            height: "100%",
        }, maxWidth: "100%", enable: { right: isResizable }, handleClasses: { right: resizableClasses.handleRight }, onResize: (_, __, ref) => {
            const newWidth = parseInt(ref.style.width, 10);
            setSidebarWidth(newWidth);
        }, children: _jsxs(Drawer, { variant: "persistent", open: true, sx: sx, children: [_jsx(Toolbar, { variant: "dense" }), children] }) }));
};
export default memo(ResizableDrawer);
